import React, { useEffect, useState } from "react";

const Header = () => {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const position = window.scrollY;
      setScrollPosition(position);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header
      className={`fixed hover:bg-white hover:text-[#313131] top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrollPosition > 50
          ? "bg-white shadow-lg text-[#313131]"
          : "bg-transparent text-white"
      }`}
    >
      <div className="container text=sm sm:text-xl md:text-2xl flex justify-between">
        <div className="p-4">
          <a href="/">
          <h1 className="text-xl sm:text-xl md:text-4xl font-extrabold hover:text-[#3e7bca]">Gngr</h1>
          </a>
        </div>
        <div className="my-auto">
          <ul className="nav flex align-middle gap-x-4">
            <li className="item">
              <a className="link hover:text-[#3e7bca] duration-300" href="#home">
                Home
              </a>
            </li>
            <li className="item">
              <a className="link hover:text-[#3e7bca] duration-300" href="#about">
                About
              </a>
            </li>
            <li className="item">
              <a className="link hover:text-[#3e7bca] duration-300" href="#projects">
                Projects
              </a>
            </li>
            <li className="item">
              <a className="link hover:text-[#3e7bca] duration-300" href="#contact">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
